import React, { useState, useMemo, useRef, useEffect, useCallback } from "react";
import styled from "styled-components";
import { Icon, Theme, Spacer, Input, Button } from "@dspworkplace/ui";
import API from "./api";
import { useAuth } from "../../Auth";
import useSchedulerApi from "../Scheduler/Common/api";
import toast from "../../components/Toasts/toast";
import moment from "moment";
import { dialog, dialogPromise, loadingDialog } from "../../components/Dialog";
import { confirm } from "../../components/Confirm";
import { showDriverSelection } from "./driverSelection";
import {showToast} from "../../Utilities";

const DropdownContainer = styled.div`
    position: relative;
    display: inline-block;
`;

const DropdownButton = styled.button`
    background: ${(props) => (props.hasSelection ? "transparent" : Theme.colors.info.bg)};
    border: none;
    padding: ${(props) => (props.hasSelection ? "4px 8px" : "8px")};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${Theme.colors.info.text};
    font-size: ${Theme.font.small.size};

    &:hover {
        background: ${(props) => (props.hasSelection ? Theme.colors.neutrals.silver : Theme.colors.info.border)};
    }
`;

const SelectedText = styled.span`
    text-decoration: underline;
    color: ${Theme.colors.info.text};
`;

const DropdownPanel = styled.div`
    position: absolute;
    top: 100%;
    left: ${(props) => (props.leftRightPosition === "right" ? "auto" : "0")};
    right: ${(props) => (props.leftRightPosition === "right" ? "0" : "auto")};
    width: 600px;
    max-height: 400px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border: 1px solid ${Theme.colors.neutrals.silver};
    z-index: 1000;
    overflow: hidden;
`;

const SearchContainer = styled.div`
    padding: 12px;
    border-bottom: 1px solid ${Theme.colors.neutrals.silver};
`;

const TableContainer = styled.div`
    max-height: 320px;
    overflow-y: auto;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const TableHeader = styled.th`
    text-align: left;
    padding: 10px 12px;
    background: ${Theme.colors.neutrals.white};
    font-size: ${Theme.font.extraSmall.size};
    font-weight: 600;
    color: ${Theme.colors.neutrals.gray};
    cursor: pointer;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;

    &:hover {
        background: ${Theme.colors.neutrals.silver};
    }
`;

const TableRow = styled.tr`
    border-bottom: 1px solid ${Theme.colors.neutrals.lightGray};
    cursor: pointer;
    background: ${(props) => (props.highlighted ? Theme.colors.info.bg : "transparent")};

    &:hover {
        background: ${Theme.colors.info.bg};
    }
`;

const TableCell = styled.td`
    padding: 10px 12px;
    font-size: ${Theme.font.small.size};
    white-space: nowrap;
`;

const ShiftBadge = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const ShiftColorDot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => props.color || Theme.colors.neutrals.gray};
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
`;

const ClearButton = styled.span`
    cursor: pointer;
    color: ${Theme.colors.neutrals.gray};

    &:hover {
        color: ${Theme.colors.error.text};
    }
`;

// const formatWaveTime = (time) => {
//     if (!time) return '';
//     const [hours, minutes] = time.split(':');
//     const h = parseInt(hours, 10);
//     const ampm = h >= 12 ? 'PM' : 'AM';
//     const hour12 = h % 12 || 12;
//     return `${hour12}:${minutes} ${ampm}`;
// };

const RouteCodeSelectorEnhanced = ({ driver, addChange, pageLoadOut, isEnable = true }) => {
    
    const { api } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortColumn, setSortColumn] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const [selectedRouteCodes, setSelectedRouteCodes] = useState(
        driver.routeCode ? driver.routeCode.map((r) => r.substring(0, r.indexOf("-"))) : []
    );
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [routeCodes, setRouteCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [keyCounter, setKeyCounter] = useState(0);
    const searchInputRef = useRef(null);
    const [enableAddButton, setEnableAddButton] = useState(false);
    // const schedulerApi = useSchedulerApi();
    const [position, setPosition] = useState(null);
    const dropdownRef = useRef(null);
    const { getTodayRouteCodes, getRouteCodes, removetRouteCode, saveShiftRouteCodes, reassignRouteCodes,deleteRouteCodes} =
        useSchedulerApi();
    useEffect(() => {
        setSelectedRouteCodes(driver.routeCode ? driver.routeCode.map((r) => r.substring(0, r.indexOf("-"))) : []);
    }, [driver.routeCode])
    const loadRouteCode = useCallback(async () => {
        setLoading(true);
        try {
            await getTodayRouteCodes({
                station: driver.stationId,
                dateCreated: driver.shiftDate,
            }).then(
                (response) => {
                    if (!response) return false;

                    // let codes = response.data.data.codes.map((c) => ({
                    //     name: c.code,
                    //     value: c.code,
                    // }));
                    // selected: temp.includes(c.code),
                    setSearchTerm("");
                    setRouteCodes(response.data.data.codes);
                    // return codes;
                },
                (error) => {
                    if (error.response)
                        toast({
                            type: "error",
                            title: "Error",
                            content: error.response.data.message,
                        });
                }
            );
            // const data = await API.fetchrouteCodesDataEnhanced(
            //     {
            //         date: driver.shiftDate,
            //         driver: driver.driverId,
            //         id: driver.id,
            //         station: driver.stationId,
            //     },
            //     api
            // );
        } catch (error) {
            console.error("Error loading routeCodes:", error);
        }
        setLoading(false);
    }, [driver, api]);

    // Sort and filter routeCodes
    const sortedAndFilteredRouteCodes = useMemo(() => {
        let filtered = routeCodes.filter((routeCode) => {
            const searchLower = searchTerm.toLowerCase();
            const codeMatch = routeCode.code?.toLowerCase().includes(searchLower);
            const shiftMatch = routeCode.shiftName?.toLowerCase().includes(searchLower);
            const assignmentMatch = routeCode.driverName?.toLowerCase().includes(searchLower);
            return codeMatch || assignmentMatch || shiftMatch;
        });

        filtered.sort((a, b) => {
            const aUnassigned = !a.driverName ? 0 : 1;
            const bUnassigned = !b.driverName ? 0 : 1;
            if (aUnassigned !== bUnassigned) return aUnassigned - bUnassigned;

            const aShift = a.shiftName || "";
            const bShift = b.shiftName || "";
            if (aShift !== bShift) return aShift.localeCompare(bShift);

            return a.code.localeCompare(b.code, undefined);
        });

        // Apply column sort if selected
        if (sortColumn) {
            filtered.sort((a, b) => {
                let aVal, bVal;

                if (sortColumn === "code") {
                    aVal = a.code || "";
                    bVal = b.code || "";
                } else if (sortColumn === "driverName") {
                    aVal = a.driverName || "";
                    bVal = b.driverName || "";
                } else if (sortColumn === "shiftName") {
                    aVal = a.shiftName || "";
                    bVal = b.shiftName || "";
                }

                const comparison = aVal.localeCompare(bVal, undefined, { numeric: true });
                return sortDirection === "asc" ? comparison : -comparison;
            });
        }
        setKeyCounter(keyCounter + 1);
        return filtered;
    }, [routeCodes, searchTerm, sortColumn, sortDirection]);

    useEffect(() => {
        const searchLower = searchTerm.trim().toLowerCase();
        const exists = routeCodes.some(
            (routeCode) => routeCode.code?.toLowerCase() === searchLower
        );
        setEnableAddButton(!exists);
    }, [searchTerm, routeCodes]);

    // Focus search input when dropdown opens
    useEffect(() => {
        if (isOpen) {
            loadRouteCode();
            // setTimeout(() => {
            //     if (searchInputRef.current) {
            //         searchInputRef.current.focus();
            //     }
            // }, 100);
            setHighlightedIndex(0);
            // Fix the popup route code
            const rect = dropdownRef.current?.getBoundingClientRect();
            if (rect) {
                const panelWidth = 600;
                const spaceRight = window.innerWidth - rect.left;
                setPosition(spaceRight >= panelWidth + 20 ? "left" : "right");
            }
        }
    }, [isOpen]);

    // Handle keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isOpen) return;

            if (e.key === "ArrowDown") {
                e.preventDefault();
                setHighlightedIndex((prev) => (prev < sortedAndFilteredRouteCodes.length - 1 ? prev + 1 : prev));
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : 0));
            } else if (e.key === "Enter" && sortedAndFilteredRouteCodes.length > 0) {
                e.preventDefault();
                handleSave(sortedAndFilteredRouteCodes[highlightedIndex]);
            } else if (e.key === "Escape") {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
            return () => window.removeEventListener("keydown", handleKeyDown);
        }
    }, [isOpen, highlightedIndex, sortedAndFilteredRouteCodes]);

    const handleSave = async (dataRouteCode) => {
        let oldCodes = [...driver.routeCode];
        let tempRouteCodesWithId = [dataRouteCode.id+'-'+dataRouteCode.code];
        let tempRouteCodes = [dataRouteCode.code];

        if (tempRouteCodes.length == 1 && driver.isOpenShift == false) {
            setLoading(true);
            let oldDriverCodes = await getRouteCodes({
                station: driver.stationId,
                date: driver.shiftDate,
                week: moment(driver.shiftDate).utc().isoWeek(),
                code: tempRouteCodes[0],
            });
            if (oldDriverCodes.status !== 200) {
                showToast({
                    type: "Error",
                    title: "We are sorry 😥.",
                    content: `Something went wrong. Please try again`,
                });
                return;
            }
            setLoading(false);
            let isOpenRouteCode = false;
            let isDriverRouteCode = false;

            let openRouteCode = [];
            let driverRouteCode = [];

            await tempRouteCodes.forEach((item) => {
                oldDriverCodes.data.data.routeCodes.open.forEach((openC) => {
                    if (openC.code.indexOf(item) > -1) {
                        isOpenRouteCode = true;
                        openRouteCode = openC;
                    }
                });
                oldDriverCodes.data.data.routeCodes.driver.forEach((driverC) => {
                    if (driverC.code.indexOf(item) > -1) {
                        isDriverRouteCode = true;
                        driverRouteCode = driverC;
                    }
                });
            });            

            if (isDriverRouteCode === true && isOpenRouteCode === true) {
                let confirmation = await confirm({
                    icon: true,
                    title: "Route code",
                    text:
                        "This route code is both located in Open Routes and is assigned to " +
                        driverRouteCode.name +
                        ".  Would you like to assign a third driver?",
                });
                if (!confirmation) {
                    let buttons = [
                        {
                            text: "Close",
                            type: "cancel",
                            callback: () => false,
                        },
                    ];
                    await dialog({
                        icon: <Icon.Info size="60px" color={Theme.colors.info.text} />,
                        text: "Please locate one of the existing Routes and reassign.",
                        buttons: buttons,
                    });
                    return;
                } else {
                    return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                }
            } else if (isOpenRouteCode === true) {
                if (driver.id != openRouteCode.id) {
                    let confirmation = await confirm({
                        icon: true,
                        title: "Route code",
                        text: `This Route Code already exists under the Open Routes Badge.  Would you like to assign this open Route Code to this Delivery Associate?`,
                    });
                    if (confirmation) {
                        await removetRouteCode({
                            route: openRouteCode.id,
                            code: openRouteCode.codeId,
                        }).then((response) => {
                            let oldDriver = {};
                            if (driver.viewType == "loadOut") {
                                oldDriver.routes = [];
                            } else {
                                addChange({
                                    ...oldDriver,
                                    routeId: openRouteCode.id,
                                    olsShiftIsOpen: true,
                                    driverId: null,
                                    date: openRouteCode.date,
                                    startTime: openRouteCode.startTime,
                                    codeCount: openRouteCode.codeCount,
                                    code: tempRouteCodes[0],
                                });
                            }
                        });
                        return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                    } else {
                        let confirmationOpenCode = await confirm({
                            icon: true,
                            title: "Route code",
                            text: `Are you sure you want to duplicate this Route Code assignment?`,
                        });
                        if (!confirmationOpenCode) {
                            return;
                        } else {
                            return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                        }
                    }
                } else {
                    return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                }
            } else if (isDriverRouteCode === true) {
                if (driver.id != driverRouteCode.id) {
                    let buttons = [
                        {
                            text: "Cancel",
                            type: "cancel",
                            callback: () => false,
                        },
                        {
                            text: "Duplicate",
                            inline: false,
                            style: {
                                width: "100%",
                                marginTop: 8,
                            },
                            callback: async () => {
                                return saveRouteCode(driver, oldCodes, tempRouteCodesWithId, driverRouteCode);
                            },
                        },
                    ];
                    if (driverRouteCode.uniqueIdentifier) {
                        buttons.push({
                            text: "Create New",
                            inline: false,
                            style: {
                                width: "100%",
                                marginTop: 8,
                            },
                            callback: async () => {
                                return saveRouteCode(driver, oldCodes, ['new-'+dataRouteCode.code]);
                            },
                        });
                    }
                    buttons.push({
                        text: " Reassign",
                        inline: false,
                        style: {
                            width: "100%",
                            marginTop: 8,
                        },
                        callback: async () => {
                            let oldDriver = {};
                            
                            await removetRouteCode({
                                route: driverRouteCode.id,
                                code: driverRouteCode.codeId,
                            });

                            if (driver.hasBag == true || driver.hasBag == false) {
                                return saveRouteCode(driver, oldCodes, tempRouteCodesWithId, driverRouteCode);
                            } else {
                                addChange({
                                    ...oldDriver,
                                    routeId: driverRouteCode.id,
                                    hasRouteCodeChnage: true,
                                    driverId: driverRouteCode.driverId,
                                    date: driverRouteCode.date,
                                    startTime: driverRouteCode.startTime,
                                    codeCount: openRouteCode.codeCount,
                                    code: tempRouteCodes[0],
                                });
                                return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                            }
                        },
                    });
                    await dialog({
                        icon: <Icon.Warning size="60px" color={Theme.colors.warnings.text} />,
                        title: "Driver Route Code",
                        text:
                            "This Route Code is already assigned to " +
                            driverRouteCode.name +
                            ". Would you like to reassign or duplicate the Route Code?",
                        buttons: buttons,
                    });
                } else {
                    return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
                }
            } else {
                return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
            }
        } else {
            return saveRouteCode(driver, oldCodes, tempRouteCodesWithId);
        }
    };

    const saveRouteCode = async (driver, oldCodes, tempRouteCodes, driverRouteCode = null) => {
        setLoading(true);
        let mergedRouteCode = [...oldCodes,...tempRouteCodes];
        driver.routeCode = mergedRouteCode;
        return saveShiftRouteCodes({
            shift: {
                stationId: driver.stationId,
                routeId: driver.id,
                date: driver.shiftDate,
            },
            codes: mergedRouteCode,
        }).then(
            (response) => {
                if (!response) {
                    showToast({
                        type: "Error",
                        title: "We are sorry 😥.",
                        content: `Something went wrong. Please try again`,
                    });
                    return;
                }
                if(driver?.deleteRouteCodeFromOpenShift && driver?.deleteRouteCodeFromOpenShift === true) {
                    addChange({actions:'onRouteChange'});
                } else {
                    addChange({
                        ...driver,
                        routeId: driver.id,
                        driverRouteCode: driverRouteCode
                    });
                }
                setLoading(false);
            },
            (error) => {
                driver.routeCode = oldCodes;
                if (error.response)
                    toast({
                        type: "error",
                        title: "Error",
                        content: error.response.data.message,
                    });
            }
        ).finally(setIsOpen(false));
    };

    const handleNewCreate = () => {
        handleSave({ id:"0", code: searchTerm });
    };

    const handleReassign = (hide) => {
        setIsOpen(false);
        showDriverSelection(
            {
                children: (
                    <>
                        {/*<Label>Reassign Routes</Label>
                        <Text>{driver.routeCode.join(', ')}</Text>*/}
                    </>
                ),
            },
            api,
            {
                type: "REPLACE_DRIVER",
                station: driver.stationId,
                stationTimezone: JSON.parse(localStorage.getItem("station")).timezone,
                date: driver.date,
                routeId: driver.id,
                route: driver.id,
                shiftDate: moment(driver.date).format("YYYY-MM-DD"),
                driverId: driver.driverId,
                routeCode: driver.routeCode,
                selectedSingleDriver: true
            }
        ).then((newDriver) => {
            setIsOpen(false);
            if (!newDriver) return;

            reassignRouteCodes({
                routeId: driver.id,
                newDriver: newDriver.driver.id,
                routeCodes: newDriver.routeCodes,
                timezoneOffset: new Date().getTimezoneOffset()
            }).then((response) => {
                let oldRoutes = driver.routeCode.filter(function (val) {
                    return newDriver.routeCodes.indexOf(val) == -1;
                });
                addChange(
                    {
                        ...driver,
                        routeId: driver.id,
                        routeCode: oldRoutes,
                        reassignRouteCode: newDriver
                    },
                    response.data.data.reassignRouteCodes
                );
            });
        });
    };

    const handleDeleteSelection = (routeCodeId) => {
        //Open Shift Delete Route Code
        if (driver.driverId === "0.0.0" && driver.isOpenShift === true) {
            driver.deleteRouteCodeFromOpenShift = true;
            return saveRouteCode(driver, [], []);
        } else {
            //Delete Route Code
            const routeCodeIds = Array.isArray(routeCodeId)
                ? routeCodeId.map(item => item.split("-")[0])
                : [routeCodeId];
            setLoading(true);
            deleteRouteCodes({
                routeId: driver.id,
                routeCodeId: routeCodeIds
            }).then((response) => {
                addChange({actions:'onRouteChange'});
            }).finally(() => setIsOpen(false))
        }
    };

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortDirection("asc");
        }
    };

    const enabled = isEnable;

    if (!enabled) {
        return (
            <span>
                {selectedRouteCodes ||
                    driver.routeCode
                        .map((r) => {
                            let rArr = r.split("-");
                            return rArr[1];
                        })
                        .join(",") ||
                    "–"}
            </span>
        );
    }

    return (
        <DropdownContainer ref={dropdownRef}>
                {driver.routeCode.length > 0 ? (
                    <>
                        <DropdownButton hasSelection={driver.routeCode.length > 0}>
                        <SelectedText>
                            {selectedRouteCodes?.routeCode || driver.routeCode.map((c, index) => {
                                let rArr = c.split("-");
                                if (rArr[1]) {
                                    if (rArr[1].includes(' Duplicate!')) {
                                        return <><div >{rArr[1].replace(" Duplicate!", "")}</div><div style={{ color: "red", fontSize: '10px' }}>{' Duplicate!'}{index < (driver.routeCode.length - 1) && ','}</div></>
                                    } else {
                                        return <div >{rArr[1]}{index < (driver.routeCode.length - 1) && ','}</div>
                                    }
                                }
                            })}
                        </SelectedText>
                        <Icon.Edit size="20px" onClick={() => setIsOpen(!isOpen)} />
                        <Icon.Replace
                            onClick={() => {
                                handleReassign()
                            }}
                            style={{ top: 10, right: 15 }}
                            size="20px"
                        />
                        <Icon.Trash size="20px" color={Theme.colors.error.text} onClick={() => handleDeleteSelection(driver.routeCode)} />
                        {/* <ClearButton onClick={handleClearSelection}>
                            <Icon.Times size="14px" />
                        </ClearButton> */}
                        </DropdownButton>
                    </>
                ) : (
                    <DropdownButton><Icon.Plus size="20px" onClick={() => setIsOpen(!isOpen)}/></DropdownButton>
                )}

            {isOpen && (
                <>
                    <Overlay onClick={() => setIsOpen(false)} />
                    <DropdownPanel leftRightPosition={position}>
                        <SearchContainer>
                            <Input
                                ref={searchInputRef}
                                placeholder="Search routeCodes..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="big"
                            />
                            <Spacer left={3} inline>
                                <Button
                                    size="medium"
                                    type="primary"
                                    onClick={async () => {
                                        handleNewCreate();
                                    }}
                                    disabled={enableAddButton == false || searchTerm.length == 0}
                                >
                                    Add
                                </Button>
                            </Spacer>
                        </SearchContainer>

                        <TableContainer>
                            {loading ? (
                                <Spacer all={3} style={{ textAlign: "center" }}>
                                    Loading...
                                </Spacer>
                            ) : (
                                <Table>
                                    <thead>
                                        <tr>
                                            <TableHeader onClick={() => handleSort("code")}>
                                                Route Code{" "}
                                                {sortColumn === "code" && (sortDirection === "asc" ? "↑" : "↓")}
                                            </TableHeader>
                                            <TableHeader onClick={() => handleSort("driverName")}>
                                                Currently Assigned{" "}
                                                {sortColumn === "driverName" && (sortDirection === "asc" ? "↑" : "↓")}
                                            </TableHeader>
                                            <TableHeader onClick={() => handleSort("shiftName")}>
                                                Shift Type{" "}
                                                {sortColumn === "shiftName" && (sortDirection === "asc" ? "↑" : "↓")}
                                            </TableHeader>
                                            <TableHeader>
                                            </TableHeader>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedAndFilteredRouteCodes.map((routeCode, index) => (
                                            <TableRow
                                                key={index + "-" + keyCounter}
                                                // highlighted={index === highlightedIndex}
                                                highlighted={selectedRouteCodes.includes(routeCode.id.toString())}
                                                onClick={() => {
                                                    if (!selectedRouteCodes.includes(routeCode.id.toString())) {
                                                        handleSave(routeCode)
                                                    }
                                                    return true;
                                                }}
                                            >
                                                <TableCell>{routeCode.code}</TableCell>
                                                <TableCell>{routeCode.driverName || "–"}</TableCell>
                                                <TableCell>
                                                    {routeCode?.shiftName ? (
                                                        <ShiftBadge>
                                                            <ShiftColorDot color={routeCode.shiftColor} />
                                                            {routeCode.shiftName}
                                                        </ShiftBadge>
                                                    ) : (
                                                        "–"
                                                    )}
                                                </TableCell>
                                                <TableCell> {(selectedRouteCodes.includes(routeCode.id.toString()) && ((routeCode.driverId == driver.driverId) || (driver.isOpenShift == true && driver.id == routeCode.driverRouteId)))?<Icon.Trash size="22px" color={Theme.colors.error.text} onClick={()=>handleDeleteSelection(routeCode.id)} />:"" }</TableCell>
                                            </TableRow>
                                        ))}
                                        {sortedAndFilteredRouteCodes.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                                                    No routeCodes found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </TableContainer>
                    </DropdownPanel>
                </>
            )}
        </DropdownContainer>
    );
};

export default RouteCodeSelectorEnhanced;
